import { onDocumentReady, expose } from '../../main';
import { log } from '../../utils';
import * as utils from './utils';
import {
  items,
  registerRowItem,
  addTypes,
  removeTypes,
  replaceTypes,
} from './rowItems';
import {
  addRowItemsConfig,
  removeRowItemValidations,
} from './itemConfig';
import { addValidation, validations } from './validations';
import { initForms, getForm, getFormItem } from './form';

export {
  getForm,
  getFormItem,
  registerRowItem,
};

expose({
  forms: {
    validations,
    get items() {
      log.warn('Do not use items directly, use getFormItem instead');
      return items;
    },
    utils,
    addTypes,
    removeTypes,
    replaceTypes,
    addRowItemsConfig,
    addValidation,
    removeRowItemValidations,
    getForm,
    getFormItem,
  },
});

onDocumentReady('Forms', () => {
  initForms();
});
